import { clsx } from "clsx";
import React from "react";
import { useDomViewport } from "web/react/hooks/use-dom-viewport/use-dom-viewport";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./ccpa-option.module.css";

function CcpaOption(): JSX.Element | null {
    const { isDomLoaded } = useDomViewport();
    if (isDomLoaded) {
        return (
            <div className={styles.optOutWidgetContainer}>
                <p>{gettext("privacy_policy.california_privacy_rights.cookies_link")}</p>
                <a
                    id="ot-sdk-btn"
                    // styling applied directly in cookie management platform
                    className={clsx(styles.link, "ot-sdk-show-settings")}
                >
                    {gettext("privacy_policy.california_privacy_rights.do_not_sell_or_share.label")}
                </a>
            </div>
        );
    } else {
        return null;
    }
}

export default CcpaOption;
